<template>
    <div>
        <el-table
            v-loading="loading"
            :data="list"
            :header-cell-style="{ background: '#d1e1ff', 'font-size': '12px' }"
            size="mini"
            :empty-text="
                datasrow.ad_min_name_tag == 0
                    ? '数据尚未读取完成，请等待完成后再点击获取列表数据！'
                    : '暂无数据'
            "
            ref="multipleTables"
        >
            <el-table-column width="60" align="center" label="">
                <template slot-scope="scope">
                    <el-checkbox
                        :value="dataArr.indexOf(scope.row.id) > -1"
                        @change="checkboxChange(scope.row.id)"
                    ></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column label="广告组合名称" align="center" width="200">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{
                        scope.row.ad_min_name
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="大词建议竞价" align="center" width="120">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{
                        scope.row.suggest_bidding
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="目标acos" align="center" width="150">
                <template slot-scope="scope">
                    <span style="word-break: break-word !important;">{{
                        scope.row.target_acos
                    }}</span>
                </template>
            </el-table-column>
            <el-table-column label="词根" align="center" min-width="200">
                <template slot-scope="scope">
                    <el-tag
                        v-for="(item, i) in scope.row.manual_root"
                        :key="i"
                        style="margin: 5px 10px 5px 0;"
                        >{{ item }}</el-tag
                    >
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import * as api from "@/api/adv/adv";
export default {
    props: {
        datasrow: {
            type: Object,
            default: () => {}
        },
        dataArr: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            list: [],
            record_id: 0,
            filter: {},
            formData: {}
        };
    },
    methods: {
        getList() {
            let obj = {};
            obj.record_id = this.datasrow.id;
            this.loading = true;
            api.get_ad_min_name_list(obj)
                .then(async res => {
                    this.loading = false;
                    if (res.code === 0) {
                        this.list = res.data;
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        checkboxChange(id) {
            this.$emit("with-data", id);
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.el-tooltip__popper {
    max-width: 300px !important;
}
</style>
<style type="text/scss" lang="scss" scoped>
.pen {
    cursor: pointer;
}
.pen:hover {
    text-decoration: underline;
}
.line {
    display: inline-block;
}
/deep/ .el-divider--horizontal {
    margin: 8px 0 4px 0 !important;
}
.filter-block {
    background-color: #a9c7ff;
    padding: 6px 6px 6px 10px;
    font-size: 18px;
    color: #333;
    margin: 0;
    display: flex;
    // justify-content: space-between;
    align-items: center;
}
.filter-block-left {
    display: flex;
    align-items: center;
}
/deep/ .el-table--border {
    border: none;
}
</style>
